import SectionHead from "./SectionHead";

const CHAPTERS = [
  { no: "01", phase: "起因", color: "secondary", title: "决赛入围引争议", desc: "一张流出名单让本季最终回还没开播就先吵上热搜。" },
  { no: "02", phase: "经过", color: "secondary", title: "质疑与对峙蔓延", desc: "路透画面与预告对不上，双方支持者各执一词。" },
  { no: "03", phase: "高潮", color: "accent", title: "加长花絮炸场", desc: "制作组放出的完整未剪辑版，信息量直接拉满。" },
  { no: "04", phase: "转折", color: "secondary", title: "直播澄清与道歉", desc: "当事人亲自回应，官方同步重剪并公开致歉。" },
  { no: "05", phase: "大结局", color: "primary", title: "真相尘埃落定", desc: "最终结果公布，胜负归属与去向迎来真正的句号。" },
  { no: "06", phase: "收尾", color: "accent", title: "片尾彩蛋与讨论", desc: "结局之外还埋了新伏笔，收尾讨论仍在继续。" },
];

const toneClass: Record<string, { chip: string; text: string }> = {
  secondary: { chip: "bg-secondary-100 text-secondary-900", text: "text-secondary-700" },
  accent: { chip: "bg-accent-100 text-accent-800", text: "text-accent-700" },
  primary: { chip: "bg-primary-100 text-primary-700", text: "text-primary-600" },
};

export default function Overview() {
  return (
    <section id="overview" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="page-shell">
        <SectionHead
          kicker="全程章节导读"
          title="整件事，先看这一张地图"
          desc="下面六段就是这次 88吃瓜全程的骨架。想速览就先扫目录，想知道细节就跳到时间线或大结局板块，按需点读、各取所需。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CHAPTERS.map((c) => {
            const t = toneClass[c.color];
            return (
              <a
                key={c.no}
                href={c.color === "primary" || c.color === "accent" ? "#finale" : "#timeline"}
                className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-100/70 p-6 transition-colors hover:border-primary-200 hover:bg-background-100"
              >
                <div className="flex items-start justify-between">
                  <span className={`chip px-3 py-1 text-xs font-bold ${t.chip}`}>{c.phase}</span>
                  <span className="font-display text-4xl leading-none text-foreground-200 group-hover:text-primary-300">
                    {c.no}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-black text-foreground-950 md:text-lg">{c.title}</h3>
                <p className="mt-2 text-sm text-foreground-700">{c.desc}</p>
                <div className={`mt-4 inline-flex items-center gap-1 text-xs font-bold ${t.text}`}>
                  查看这一节
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}